//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { moment } from "~/plugins/moment";
import IconView from "./IconView.vue";
import AsyncObjectSnippetTooltip from "../AsyncObjectSnippetTooltip.vue";
import {
  intToHumanReadable,
  eToNumber,
  humanReadablePropValue,
  computeRenderIconOfProp
} from "../../utils/converter.js";
import { buildMaskStyle } from "@/utils/helpers.js";
import { getDefaultThemeSettings } from "@/constants/ui.js";
import TheMaskIcon from "@/components/objects/TheMaskIcon.vue";
import { gsap } from 'gsap'

export default {
  name: "CharacteristicsView",
  components: {
    AsyncObjectSnippetTooltip,
    IconView,
    TheMaskIcon,
  },
  provide: {
    source: 'objCharacteristics'
  },
  props: {
    properties: {
      type: Array,
      default: new Array()
    },
    palette: {
      type: Object,
      default: null,
    },
    design: {
      type: String,
      default: 'props_default'
    },
    designTheme: {
      type: String,
      default: null
    },
    designExtra: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      entranceObserver: null,
      entranceTween: null,
      entranceAnimated: false,
    }
  },
  computed: {
    currentDesign() {
      const design = this.design || 'props_default'
      if (design === 'default') return 'props_default'
      return design
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette || []
    },
    themeDefaults() {
      const themes = getDefaultThemeSettings(this.currentDesign, 'props', this.$store)?.themes || []
      const normalizedTheme = String(this.designTheme || '').trim().toLowerCase()
      if (!normalizedTheme) return themes[0] || {}
      return themes.find(theme => String(theme?.theme || '').trim().toLowerCase() === normalizedTheme) || themes[0] || {}
    },
    normalizedDesignExtra() {
      const defaults = { ...(this.themeDefaults || {}) }
      const effectiveDesignExtra = this.designTheme === 'custom' ? (this.designExtra || {}) : {}
      return {
        ...defaults,
        ...effectiveDesignExtra,
        first_block: {
          ...(defaults.first_block || {}),
          ...(effectiveDesignExtra.first_block || {})
        },
        bg: {
          ...(defaults.bg || {}),
          ...(effectiveDesignExtra.bg || {})
        },
        block_border: {
          ...(defaults.block_border || {}),
          ...(effectiveDesignExtra.block_border || {})
        },
        icon_border: {
          ...(defaults.icon_border || {}),
          ...(effectiveDesignExtra.icon_border || {})
        },
        icon_bg: {
          ...(defaults.icon_bg || {}),
          ...(effectiveDesignExtra.icon_bg || {})
        },
        icon_color: {
          ...(defaults.icon_color || {}),
          ...(effectiveDesignExtra.icon_color || {})
        },
        text: {
          ...(defaults.text || {}),
          ...(effectiveDesignExtra.text || {})
        },
        mask: {
          ...(defaults.mask || {}),
          ...(effectiveDesignExtra.mask || {})
        },
      }
    },
    // myPalette() {
    //   return this.findPalette(this.palette || this.normalizedDesignExtra?.bg?.palette || 'Pal001')
    // },
    textColor() {
      return this.normalizedDesignExtra?.text?.color || 'var(--black)'
    },
    iconColor() {
      const rawColor = this.normalizedDesignExtra?.icon_color?.color || 'white'
      return `picto_${rawColor === 'vistat' ? '328fe5' : rawColor}`
    },
    siTypes() {
      return this.$store.state["property_templates"]["consts"].si
    },
    processedProperties() {
      return [...this.properties].map(({ ...prop }) => {
        prop.renderCollectIcon = computeRenderIconOfProp(prop)
        prop.select_related_vistat_object = null

        if (prop.template?.value?.type === 'select') {
          const matchOptionsWithRelatedObject = prop.template?.value?.options?.filter(x => prop.value.includes(x.key) && x.vistat_object) || []
          if (matchOptionsWithRelatedObject.length) prop.select_related_vistat_object = matchOptionsWithRelatedObject[0].vistat_object
        }
        if (prop?.value?.type === 'select') {
          const matchOptionsWithRelatedObject = prop.value.value_annotated.filter(x => x.vistat_object)
          if (matchOptionsWithRelatedObject.length) prop.select_related_vistat_object = matchOptionsWithRelatedObject[0].vistat_object
        }

        prop.humanReadableValue = humanReadablePropValue(prop, this.$store.getters['objects/cachedObjectsGetter'])

        if ((prop.value?.type === 'plain' || prop.template?.value?.type === 'plain') && prop.humanReadableValue.length == 1) {
          try {
            prop.humanReadableValue[0][0] = this.findValueString(prop.humanReadableValue[0]);
          }
          catch (e) {
            console.error(e)
          }
        }

        if ((prop.value?.type === 'date' || prop.template?.value?.type === 'date') && prop.humanReadableValue.length == 1 && prop.date) {
          prop.humanReadableValue[0][0] = this.appendDateTime(prop.humanReadableValue[0][0], prop.date)
        }

        if ((prop.value?.type === 'date' || prop.template?.value?.type === 'date') && prop.humanReadableValue.length == 1 && prop.date) {
          if(prop.humanReadableValue[0][0]
            && prop.date["vfrom"]
            && (
              (moment(prop.humanReadableValue[0][0], "DD.MM.YYYY [г.]", true).isValid() || moment(prop.humanReadableValue[0][0], "DD.MM.YYYY [г]", true).isValid())
              || (moment(prop.humanReadableValue[0][0], "DD.MM.YYY [г.]", true).isValid() || moment(prop.humanReadableValue[0][0], "DD.MM.YYY [г]", true).isValid())
              || (moment(prop.humanReadableValue[0][0], "DD.MM.YY [г.]", true).isValid() || moment(prop.humanReadableValue[0][0], "DD.MM.YY [г]", true).isValid())
              || (moment(prop.humanReadableValue[0][0], "DD.MM.Y [г.]", true).isValid() || moment(prop.humanReadableValue[0][0], "DD.MM.Y [г]", true).isValid())

            )
          ){
            let dateTime = moment(prop.date["vfrom"], 'YYYY.MM.DDTHH:mm:ss')
            let isCreatePoint = (
              moment(prop.humanReadableValue[0][0], "DD.MM.YYYY [г]", true).isValid()
              || moment(prop.humanReadableValue[0][0], "DD.MM.YYY [г]", true).isValid()
              || moment(prop.humanReadableValue[0][0], "DD.MM.YY [г]", true).isValid()
              || moment(prop.humanReadableValue[0][0], "DD.MM.Y [г]", true).isValid()
            )
            if(!(dateTime.format('HH:mm') === '00:00')){
              prop.humanReadableValue[0][0] = prop.humanReadableValue[0][0] + (isCreatePoint ? "." : "") + " в " + dateTime.format('HH:mm')
            }
          }
        }

        prop.uuid = prop.uuid || prop.id
        prop.humanLabel = prop.template_annotated?.label || prop.template?.label
        prop.vistat_object = prop.template_annotated?.vistat_object || prop.template?.vistat_object
        return prop
      })
    }
  },
  watch: {
    properties() {
      this.$nextTick(() => {
        this.cleanupEntranceAnimation()
        this.entranceAnimated = false
        this.setupEntranceAnimation()
      })
    },
  },
  created() {
    this.prefetchObjectsInfo()
  },
  mounted() {
    window.addEventListener('vistat:prepare-export', this.finishEntranceAnimationForExport)
    this.$nextTick(this.setupEntranceAnimation)
  },
  beforeDestroy() {
    window.removeEventListener('vistat:prepare-export', this.finishEntranceAnimationForExport)
    this.cleanupEntranceAnimation()
  },
  methods: {
    isEntranceExportTarget(event) {
      const element = event?.detail?.element
      return !!(element && this.$el && (this.$el === element || this.$el.contains(element) || element.contains(this.$el)))
    },
    finishEntranceAnimationForExport(event) {
      if (!this.isEntranceExportTarget(event)) return

      const targets = this.getEntranceTargets()
      this.entranceObserver?.disconnect()
      this.entranceObserver = null
      if (this.entranceTween) {
        this.entranceTween.kill()
        this.entranceTween = null
      }
      gsap.killTweensOf(targets)
      gsap.set(targets, { clearProps: 'transform,opacity' })
      this.entranceAnimated = true
    },
    getEntranceTargets() {
      const items = Array.isArray(this.$refs.propertyItems)
        ? this.$refs.propertyItems
        : [this.$refs.propertyItems].filter(Boolean)
      return items
        .map((item) => item?.querySelector?.('.item') || item)
        .filter(Boolean)
    },
    setupEntranceAnimation() {
      if (!process.client || this.entranceAnimated) return

      const targets = this.getEntranceTargets()
      if (!targets.length) return

      const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches
      if (prefersReducedMotion) {
        gsap.set(targets, { clearProps: 'transform,opacity' })
        this.entranceAnimated = true
        return
      }

      const isCompact = window.innerWidth < 720
      gsap.killTweensOf(targets)
      gsap.set(targets, {
        opacity: 0,
        y: isCompact ? 22 : 10,
        x: isCompact ? 0 : (index) => (index % 2 === 0 ? -34 : 34),
        scale: 0.98,
      })

      const animate = () => {
        if (this.entranceAnimated) return
        this.entranceAnimated = true
        this.entranceTween = gsap.to(targets, {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1,
          duration: 1.32,
          ease: 'power3.out',
          stagger: {
            each: 0.18,
            from: 'start',
          },
          clearProps: 'transform,opacity',
        })
      }

      if ('IntersectionObserver' in window) {
        this.entranceObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.entranceObserver?.disconnect()
            this.entranceObserver = null
            animate()
          }
        }, {
          threshold: 0.18,
          rootMargin: '0px 0px -12% 0px',
        })
        this.entranceObserver.observe(this.$el)
      } else {
        animate()
      }
    },
    cleanupEntranceAnimation() {
      this.entranceObserver?.disconnect()
      this.entranceObserver = null
      if (this.entranceTween) {
        this.entranceTween.kill()
        this.entranceTween = null
      }
      gsap.killTweensOf(this.getEntranceTargets())
    },
    appendDateTime(value, date) {
      const source = date?.vfrom || date?.vFrom
      if (!value || !source) return value

      const dateTime = moment(source, 'YYYY.MM.DDTHH:mm:ss', true)
      if (!dateTime.isValid() || dateTime.format('HH:mm') === '00:00') return value

      const cleanValue = String(value).replace(/<[^>]*>/g, '').trim()
      if (!/^\d{2}\.\d{2}\.\d{1,4}(?:\s+\S+\.?)?$/.test(cleanValue)) return value

      return `${value} ${dateTime.format('HH:mm')}`
    },
    findValueString(arr) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];

        // Если элемент является объектом, проверяем его ключи
        if (typeof element === 'object' && element !== null) {
          if (element.hasOwnProperty('value')) {
            return element['value'];
          }

          // Если элемент является объектом или массивом, рекурсивно ищем в нем
          if (Array.isArray(element)) {
            const result = this.findValueString(element);
            if (result !== undefined) {
              return result;
            }
          } else {
            const result = this.findValueString(Object.values(element));
            if (result !== undefined) {
              return result;
            }
          }
        }
        else if ((typeof element === 'number' || typeof element === 'string') && element !== null) {
          return element
        }
      }

      return '&nbsp';
    },
    isSiType(prop) {
      return Boolean(prop.value?.type === 'number' && prop.value.si) || Boolean(prop.template?.value?.type === "number" && prop.template?.value_si)
    },
    siType(prop) {
      if (prop.value?.type === 'number' && prop.value.si) return prop.value.si.si
      const siType = this.siTypes.find(x => {
        return x.id === (prop.value_si || prop.template?.value_si)
      })

      return siType ? siType.si : 'ОШИБКА'
    },
    intToHumanReadable,
    findPalette(paletteId) {
      if (!paletteId || !this.paletteList.length) return null
      return this.paletteList.find(el => el.id === paletteId) || null
    },
    pickColor(config, index, fallback = null) {
      if (!config) return fallback
      if (config.color) return config.color
      if (config.palette) {
        const palette = this.findPalette(config.palette)
        if (palette) {
          const colors = [palette.main_color, ...(palette.colors || [])].filter(Boolean)
          if (colors.length) return colors[index % colors.length]
        }
      }
      return fallback
    },
    getItemStyle(index) {
      const borderColor = this.pickColor(this.normalizedDesignExtra?.block_border, index, null)
      return {
        backgroundColor: this.pickColor(this.normalizedDesignExtra?.bg, index, {}),
        borderBottom: borderColor ? `1px ${this.currentDesign === 'props_default' ? 'dashed' : 'solid'} ${borderColor}` : undefined,
        borderLeft: borderColor && this.currentDesign !== 'props_default' ? `1px solid ${borderColor}` : undefined,
      }
    },
    getIconContainerStyle(index) {
      return {
        borderColor: this.pickColor(this.normalizedDesignExtra?.icon_border, index, 'transparent'),
      }
    },
    getIconShapeStyle(index) {
      return {
        backgroundColor: this.pickColor(this.normalizedDesignExtra?.icon_bg, index, null),
      }
    },
    getMaskStyle() {
      return buildMaskStyle(this.normalizedDesignExtra?.mask?.name)
    },
    buildTooltip(prop) {
      if (prop?.value?.type === 'number' || prop.template?.value?.type === 'number') {
        const val = prop?.value?.type === 'number' ? prop.value.value : prop.value
        if (typeof val === 'string' || typeof val === 'number') {
          return `${eToNumber(val)} ${this.isSiType(prop) ? this.siType(prop) : ''}`
        } else if (val[0] === val[1]) {
          return `${eToNumber(val[0])} ${this.isSiType(prop) ? this.siType(prop) : ''}`
        } else {
          if (val[0] >= 0 && val[1] >= 0) {
            return `${eToNumber(val[0])} - ${eToNumber(val[1])} ${this.isSiType(prop) ? this.siType(prop) : ''}`
          } else {
            return `${eToNumber(val[0])}...${eToNumber(val[1])} ${this.isSiType(prop) ? this.siType(prop) : ''}`
          }
        }
      } else if (prop.value?.type === 'select' || prop.template?.value?.type === 'select') {
        const candidates = humanReadablePropValue(prop).map(x => x[0]).join("\n")
        return candidates.length > 55 ? candidates : null
      } else return null
    },
    prefetchObjectsInfo() {
      let forFetch = []
      this.properties.forEach(prop => {
        if (prop.template?.value?.type === 'object') {
          forFetch.push(...Array.isArray(prop.value) ? prop.value : [prop.value])
          //this.$store.dispatch("objects/fetchAndSaveCache", Array.isArray(prop.value) ? prop.value : [prop.value])
        }
      })
      this.$store.dispatch("objects/fetchAndSaveCache", forFetch)
    }
  }
}
